var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarCurrent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66242 1.80888C7.80013 1.52985 8.19802 1.52985 8.33573 1.80888L10.1184 5.42097C10.1731 5.53177 10.2788 5.60857 10.4011 5.62634L14.3872 6.20556C14.6952 6.25031 14.8181 6.62872 14.5953 6.84592L11.7109 9.65753C11.6224 9.74378 11.582 9.86804 11.6029 9.98983L12.2838 13.9599C12.3364 14.2666 12.0145 14.5004 11.7391 14.3557L8.17377 12.4812C8.0644 12.4237 7.93374 12.4237 7.82437 12.4812L4.25903 14.3557C3.98361 14.5004 3.66172 14.2666 3.71432 13.9599L4.39524 9.98983C4.41612 9.86804 4.37575 9.74378 4.28727 9.65753L1.40285 6.84592C1.18003 6.62872 1.30298 6.25031 1.61091 6.20556L5.59708 5.62634C5.71936 5.60857 5.82506 5.53177 5.87975 5.42097L7.66242 1.80888Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarCurrent);
export default __webpack_public_path__ + "static/media/starCurrent.a06a82c9fb8c8b1aafba96ba31aff59c.svg";
export { ForwardRef as ReactComponent };